import axios from "axios";
import md5 from "js-md5";
import JSONbig from 'json-bigint'; // npm install json-bigint
import { getToken, clearToken, setToken, setStorage, getStorage, removeStorage } from '@/utils'
import { ElMessage } from "element-plus";
import router from '@/router';
const service = axios.create({
    // baseURL: process.env.VUE_APP_API_BASE_URL,
    baseURL: '',
    // baseURL: '/api',
    // 请求超时时长
    // timeout: 15000,
    // 跨域请求，允许保存cookie
    withCredentials: false,
    transformResponse: [data => {
        try {
            // 使用 json-bigint 解析响应数据
            return JSONbig.parse(data);
        } catch (e) {
            return data;
        }
    }]
});

// 添加请求拦截器
service.interceptors.request.use(
    config => {
        const token = getToken()
        const time = new Date() * 1
        if (token) {
            config.headers.token = token
        }
        config.headers.time = time
        config.headers.sign = md5(time + '12ea76bf1968ce4657b9b33afad9ef91')
        return config
    }
)

// 添加响应拦截器
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.code != 0) {
                if (response.data.message == "请您重新登录系统！") {
                    clearToken()
                    removeStorage("permissions")
                    removeStorage("webUserVo")
                    ElMessage({
                        message: "请您重新登录系统",
                        type: "warning",
                    });
                    router.push("/");
                }
                return Promise.reject(response.data.message)
            }
            return response.data;
        } else {
            return Promise.reject(new Error("Error with status code " + response.status));
        }
    },
    error => {
        return Promise.reject(error);
    }
)
// JSON格式
export const request = ({ method, url, data = {},params }) => {
    return service({
        url,
        method,
        params,
        data: {
            requestBody: data
        },
        responseType: 'json',
        headers: {
            "Content-type": "application/json;charset=utf-8"
        }
    })
}
export const requestNoBody = ({ method, url, data }) => {
    return service({
        url,
        method,
        data,
        responseType: 'json',
        headers: {
            "Content-type": "application/json;charset=utf-8"
        }
    })
}
// 表单格式
export const requestForm = ({ method, url, data = {} }) => {
    return service({
        url,
        method,
        data: {
            requestBody: data
        },
        responseType: 'json',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

// 文件上传
export const upload = ({ method, url, files = {}, data = {} }) => {
    const formData = new FormData()
    for (let key in files) {
        if (files[key].constructor === Array) {
            files[key].forEach((file) => {
                formData.append(key, file)
            })
        } else {
            formData.append(key, files[key])
        }
    }
    for (let key in data) {
        formData.append(key, data[key])
    }
    return new Promise((resolve, reject) => {
        service({
            url,
            method,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 0
        })
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
// 文件下载
const service_axios = axios.create({
    // baseURL: process.env.VUE_APP_API_BASE_URL,
    // baseURL: '/api',
    // 请求超时时长
    timeout: 5000,
    // 跨域请求，允许保存cookie
    withCredentials: false,
});
export const download = ({ method, url, data = {} }) => {
    const token = getToken()
    const time = new Date() * 1
    const sign = md5(time + '12ea76bf1968ce4657b9b33afad9ef91')
    return new Promise((resolve, reject) => {
        service_axios({
            method,
            url,
            data: {
                platform: 'app',
                requestUser: '1',
                sign: '',
                requestBody: data
            },
            responseType: 'arraybuffer',
            headers: { token, time, sign }
        })
            .then((res) => {
                console.log(res, "------dv-------")

                const fileName = decodeURI(res.headers['content-disposition'].split('filename=')[1])
                const blob = new Blob([res.data], {
                    type: 'application/' + fileName.split('.')[fileName.split('.').length - 1]
                })
                const a = document.createElement('a')
                a.download = fileName
                a.href = window.URL.createObjectURL(blob)
                a.click()
                a.remove()
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
